import { useMutation, useQueryClient } from '@tanstack/react-query';
import { medicalRecordsApi, type Anamnese } from '@/api';

export function useCreateAnamnese() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      medicalRecordId: string;
      chiefComplaint: string;
      historyOfPresentIllness: string;
      symptoms: Array<{ name: string; intensity: number; duration: string; location?: string }>;
      evolutionTime: string;
      currentMedications: Array<{ name: string; dosage: string; frequency: string; stillUsing: boolean }>;
      allergies: string[];
      previousDiseases: string[];
      surgeries: string[];
      weight?: number;
      height?: number;
    }) => medicalRecordsApi.createAnamnese(data),
    onSuccess: (newAnamnese: Anamnese) => {
      queryClient.invalidateQueries({
        queryKey: ['medical-records', 'record', newAnamnese.medicalRecordId],
      });
    },
  });
}
